/**
 * Pfaddaten der Symbole, die nicht nur in der Oberfläche vorkommen.
 *
 * Die Einsprungpunkte am App-Symbol (`shortcuts` im Manifest) brauchen dieselben
 * Piktogramme als PNG — gezeichnet von `scripts/build-icons.ts`. Läge die Form dort
 * ein zweites Mal, zeigte der Launcher über kurz oder lang eine andere Lupe als die
 * Navigationsleiste. Deshalb steht sie hier einmal, und beide Seiten lesen sie.
 *
 * Alle Angaben im Raster 0 0 24 24, gleiches Register wie `icons.tsx`.
 */

/** Kantenlänge des Rasters, in dem die Pfade beschrieben sind. */
export const ICON_RASTER = 24

/** Strichstärke der Oberfläche. Die PNG-Symbole zeichnen dünner — siehe build-icons.ts. */
export const ICON_STRICH = 1.75

/**
 * Lupe. Der Kreis ist bewusst als geschlossener Pfad notiert und nicht als
 * `<circle>`: Nur so lässt er sich unverändert an Canvas weiterreichen. Das `Z` ist
 * nötig, weil die eckigen Strichenden sonst an der Naht überstehen würden.
 */
export const PFAD_SUCHE = [
  'M17 10.5A6.5 6.5 0 1 1 4 10.5A6.5 6.5 0 1 1 17 10.5Z',
  'm15.5 15.5 5 5',
]

/** Katalog: vier Felder als Andeutung eines Kartensatzes. */
export const PFAD_KATALOG = ['M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z']
